import { Row, Col } from "antd";
import styled from "styled-components";
import importantIcon from "../Assets/Icons/important.svg";
import mailIcon from "../Assets/Icons/mail.svg";
import lockIcon from "../Assets/Icons/lock.svg";
import eyevisibleIcon from "../Assets/Icons/eyevisible.svg";
import eyeInvisibleIcon from "../Assets/Icons/eyeinvisible.svg";
import userIcon from "../Assets/Icons/user.svg";
import wrongIcon from "../Assets/Icons/wrong-dark.svg";
import BackArrow from "../Assets/Icons/back-arrow.svg";
import infoIcon from "../Assets/Icons/Info.svg";
import calendar from "../Assets/Icons/calendar.svg";
import clock from "../Assets/Icons/alarm-clock.svg";
import cutter from "../Assets/Icons/cutter.svg";
import cutterGray from "../Assets/Icons/cutterGray.svg";
import openBox from "../Assets/Icons/open-box.svg";
import SearchIcon from "../Assets/Icons/search.svg";

export const FullHeightRow = styled(Row)`
  height: 100vh;
  /* overflow: hidden; */
  .flexBlock {
    display: flex;
    width: 100%;
  }
  .vCenterBlock {
    align-self: center;
    justify-content: center;
  }
  @media (max-width: 992px) {
    .authLayout {
      > .ant-row {
        display: block;
        .colLayoutBlock {
          flex: 0 0 100%;
          max-width: 100%;
        }
      }
    }
  }
`;

export const RightContainer = styled.div`
  height: 100vh;
`;

export const StyledCol = styled(Col)`
  padding: 0 !important;
`;

export const AuthLeftContainer = styled.div`
  height: 100vh;
  display: flex;
  .hCenterBox {
    width: 410px;
    margin: 0 auto;
  }
  .afterSuccess {
    margin: 25px 0 30px;
  }
  .backToLoginBtn {
    width: 100%;
    height: 40px;
    border-radius: 8px;
    background-color: var(--theme-color);
    border-color: var(--theme-color);
    text-align: center;
    display: block;
    color: #fff;
    letter-spacing: 0.01em;
    font-family: var(--sf-pro-display);
    padding: 10px 0;
    margin-top: 35px;
  }
  @media (max-width: 992px) {
    height: 100%;
    padding: 60px 0;
    .hCenterBox {
      width: 480px;
    }
  }
  @media (max-width: 640px) {
    .hCenterBox {
      width: 390px;
    }
  }
  @media (max-width: 480px) {
    .hCenterBox {
      width: 310px;
    }
  }
  @media (max-width: 360px) {
    .hCenterBox {
      width: 290px;
    }
  }
`;

export const AuthTitleBlock = styled.div`
  .logo {
    width: 216px;
    img {
      width: 100%;
    }
  }
  h1 {
    font-size: 28px;
    line-height: 36px;
    color: var(--main-title);
    margin-top: 26px;
    font-family: var(--sf-pro-display-m);
  }
  p {
    color: var(--para-text);
    font-size: 18px;
    line-height: 28px;
    font-family: var(--sf-pro-text);
    letter-spacing: -0.01em;
  }
  @media (max-width: 640px) {
    h1 {
      font-size: 24px;
    }
    p {
      font-size: 14px;
      line-height: 20px;
    }
    .logo {
      width: 190px;
    }
  }
`;

export const HaberForm = styled.div`

  .ant-row {
    input[type="text"],
    .ant-input-password,
    input[type="tel"],
    select,
    .ant-select,
    textarea {
      background-color: var(--form-element-bg);
      border: 2px solid #dfe1e6;
      box-sizing: border-box;
      border-radius: 8px;
      height: 40px;
      font-size: 14px;
      font-family: var(--sf-pro-text);
      color: #323130;
      box-shadow: none !important;
      overflow: hidden;
      border-right-width: 2px !important;
      &:hover,
      &:focus {
        outline: none !important;
        border-right-width: 2px !important;
        box-shadow: none !important;
        // border-color:#DFE1E6 !important;
      }
      &.showErrorBorder {
        border-color: #ea655b !important;
      }
    }
    textarea {
      height: 60px;
      resize: none;
    }
    .ant-select-single .ant-select-selector .ant-select-selection-item {
      line-height: 38px;
    }
    .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
      height: 36px;
    }
    .ant-select-selector {
      border: none !important;
      background-color: var(--form-element-bg);
      &:focus,
      &:hover {
        outline: none !important;
        border-right-width: 2px !important;
        box-shadow: none !important;
      }
    }
    .ant-input-password {
      padding: 0px;
      input[type="password"] {
        margin: 0px;
        padding: 4px 11px !important;
        border-radius: 8px;
        background-color: var(--form-element-bg);
        &:focus {
          outline: none;
          border-right-width: 2px !important;
          box-shadow: none !important;
        }
      }
      input[type="text"] {
        border: none;
        margin: 0px;
        height: 36px;
        padding: 4px 11px !important;
      }
    }
    &.ant-form-item-has-error {
      input[type="text"],
      .ant-input-password,
      input[type="tel"],
      select,
      .ant-select {
        border-color: #ea655b !important;
        &:hover,
        &:focus {
          outline: none !important;
          border-right-width: 2px !important;
        }
      }
      .ant-input-password {
        &:focus {
          border-color: #ea655b !important;
          border-right-width: 2px !important;
        }
      }
    }
    .ant-form-item-explain-error {
      color: #ea4e2c;
      font-size: 12px;
      line-height: 16px;
      font-family: var(--sf-pro-text);
      > div {
        margin-top: 4px;
        position: relative;
        padding-left: 18px;
        &:before {
          content: "";
          position: absolute;
          left: 0px;
          top: 1px;
          width: 15px;
          height: 15px;
          background-image: url(${importantIcon});
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
    }
    .ant-form-item-explain,
    .ant-form-item-extra {
      min-height: 30px;
    }
    &.ant-form-item {
      margin-bottom: 30px;
    }
    &.ant-form-item-with-help {
      margin-bottom: 0px;
    }
  }
  .haberLogin {
    margin-top: 30px;
    .ant-row {
      input[type="text"],
      input[type="password"] {
        padding-left: 35px !important;
      }
    }
  }
  .qtyToBePlannedInput {
    margin-top: 30px;
    .ant-row {
      input[type="text"],
      input[type="password"] {
        padding-left: 7px !important;
      }
    }
  }
  .solutionInput {
    .ant-row {
      input[type="text"],
      input[type="password"] {
        border: none;
        height: 30px;
      }
    }
  }
  .mailIcon,
  .lockIcon,
  .userIcon {
    .ant-form-item-control-input-content {
      position: relative;
      &:before {
        content: "";
        position: absolute;
        background-size: contain;
        background-repeat: no-repeat;
        z-index: 2;
      }
    }
  }
  .mailIcon {
    .ant-form-item-control-input-content {
      &:before {
        left: 10px;
        top: 12px;
        width: 22px;
        height: 17px;
        background-image: url(${mailIcon});
      }
    }
  }
  .userIcon {
    .ant-form-item-control-input-content {
      &:before {
        left: 7px;
        top: 8px;
        width: 25px;
        height: 24px;
        background-image: url(${userIcon});
      }
    }
  }
  .lockIcon {
    .ant-form-item-control-input-content {
      &:before {
        left: 11px;
        top: 11px;
        width: 22px;
        height: 19px;
        background-image: url(${lockIcon});
      }
    }
    .ant-input-suffix {
      // padding-right: 10px;
      margin : 0px;
      padding : 0px;
      position: relative;

      .anticon-eye-invisible,
      .anticon-eye {
        svg {
          display: none;
        }
        &:after {
          content: "";
          position: absolute;
          background-size: contain;
          background-repeat: no-repeat;
          z-index: 2;
        }
      }
      .anticon-eye-invisible {
        &:after {
          left: -25px;
          top: 9px;
          width: 21px;
          height: 20px;
          background-image: url(${eyevisibleIcon});
        }
      }
      .anticon-eye {
        &:after {
          left: -25px;
          top: 9px;
          width: 24px;
          height: 20px;
          background-image: url(${eyeInvisibleIcon});
        }
      }
    }
  }
  .logCheck {
    span {
      color: var(--para-text);
      font-size: 14px;
      line-height: 20px;
      font-family: var(--sf-pro-text);
    }
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: var(--theme-color);
      border-color: var(--theme-color);
    }
    .ant-checkbox-inner {
      border: 2px solid #dfe1e6;
      &:focus,
      &:hover {
        border: 2px solid #dfe1e6;
      }
    }
    .ant-checkbox-checked::after {
      border: none;
    }
  }
  .btnSubmit {
    width: 100%;
    height: 40px;
    border-radius: 8px;
    background-color: var(--theme-color);
    border-color: var(--theme-color);
    &[disabled] {
      background-color: #f3f2f1;
      border-color: #f3f2f1;
      &:hover {
        background-color: #f3f2f1;
        border-color: #f3f2f1;
      }
    }
    &:hover {
      background-color: var(--theme-color-hover);
      border-color: var(--theme-color-hover);
    }
    span {
      font-size: 14px;
      letter-spacing: 0.01em;
      font-family: var(--sf-pro-display);
      display: inline;
    }
  }
  .alignedBox {
    .ant-form-item-control-input-content {
      display: flex;
      justify-content: space-between;
      a {
        color: var(--theme-color);
        font-size: 14px;
        line-height: 20px;
        font-family: var(--sf-pro-display-m);
        letter-spacing: 0.01em;
        border-bottom: 1px solid transparent;
        transition: all 0.2s ease-in-out;
        &:hover {
          color: var(--theme-color-hover);
          border-bottom: 1px solid var(--theme-color-hover);
        }
      }
    }
  }
  .ant-form-item-control-input-content input::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: #a19f9d;
    font-size: 14px;
    font-family: var(--sf-pro-text);
  }
  .ant-form-item-control-input-content input::-moz-placeholder {
    /* Firefox 19+ */
    color: #a19f9d;
    font-size: 14px;
    font-family: var(--sf-pro-text);
  }
  .ant-form-item-control-input-content input:-ms-input-placeholder {
    /* IE 10+ */
    color: #a19f9d;
    font-size: 14px;
    font-family: var(--sf-pro-text);
  }
  .ant-form-item-control-input-content input:-moz-placeholder {
    /* Firefox 18- */
    color: #a19f9d;
    font-size: 14px;
    font-family: var(--sf-pro-text);
  }
  .pageLinks {
    text-align: center;
    color: var(--theme-color);
    a {
      color: var(--theme-color);
      font-size: 12px;
      line-height: 20px;
      font-family: var(--sf-pro-display-m);
      letter-spacing: 0.01em;
      border-bottom: 1px solid transparent;
      transition: all 0.2s ease-in-out;
      &:hover {
        color: var(--theme-color-hover);
        border-bottom: 1px solid var(--theme-color-hover);
      }
    }
  }
  .haberSignup {
    .ant-row {
      &.ant-form-item {
        margin-bottom: 25px;
      }
      &.ant-form-item-with-help {
        margin-bottom: 0px;
      }
      .ant-form-item-explain,
      .ant-form-item-extra {
        min-height: 25px;
      }
    }
    .mailIcon {
      input {
        border-color: transparent;
      }
    }
  }
  // .firstPass{
  //   .ant-input-suffix{
  //     .anticon-eye-invisible{
  //       &:after{display:none}
  //     }
  //   }
  // }
  .pwdStrength {
    padding: 0px;
    li {
      list-style: none;
      color: var(--para-text);
      font-size: 12px;
      line-height: 20px;
      font-family: var(--sf-pro-text);
      letter-spacing: 0.01em;
      padding: 4px 0 4px 0px;
      span {
        margin-right: 7px;
        img {
          position: relative;
          top: -2px;
          width: 16px;
          height: 16px;
        }
      }
    }
  }
  .backToLogin {
    color: var(--theme-color);
    font-size: 14px;
    line-height: 16px;
    font-family: var(--sf-pro-display);
    letter-spacing: 0.01em;
    text-align: center;
    display: table;
    margin: 0 auto 25px;
    border-bottom: 1px solid transparent;
    transition: all 0.2s ease-in-out;
    &:hover {
      color: var(--theme-color-hover);
      border-bottom: 1px solid var(--theme-color-hover);
    }
  }
  .ant-select-arrow {
  padding-bottom : 6px;
    z-index : 0;
    .anticon-down {
      position: relative;
      &:before {
        content: "";
        position: absolute;
        top: 0px;
        left: 0px;
        width: 4px;
        height: 4px;
        z-index: 5;
        border-top: 2px solid #605e5c;
        border-right: 2px solid #605e5c;
        transform: rotate(90deg);
      }
      svg {
        display: none;
      }
    }
  }
  .antd-country-phone-input {
    padding: 0px;
    border: none;
    outline: none !important;
    box-shadow: none;
    &:hover,
    &:focus {
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
    }
    &.intlPhone {
      .ant-input-prefix {
        margin: 0;
        .ant-select-show-search {
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0;
          background-color: #edebe9;
          position: relative;
          &:before {
            content: "";
            position: absolute;
            top: 13px;
            right: 10px;
            width: 7px;
            height: 7px;
            z-index: 5;
            border-top: 2px solid #605e5c;
            border-right: 2px solid #605e5c;
            transform: rotate(135deg);
          }
          &.ant-select-open {
            &:before {
              display: none;
            }
          }
        }
      }
      .ant-select-arrow {
        color: #807e7e !important;
        font-size: 14px !important;
      }
      input[type="text"] {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: 0px;
      }
      .ant-select-selection-search input[type="search"] {
        height: 38px;
      }
    }
    &.showErrorBorder {
      /* input { */
      border-color: #ea655b !important;
      /* } */
      /* .ant-select {
        border-top-color: #ea655b !important;
        border-left-color: #ea655b !important;
        border-bottom-color: #ea655b !important;
        border: 2px solid #dfe1e6;
      } */
    }
  }

  preview of uploading image above .ant-upload-list {
    position: absolute;
    top: 0;
    width: 100%;
  }

  .ant-upload.ant-upload-drag {
    // border: 2px dashed #dfe1e6;
    // background-color: var(--form-element-bg);
    // border-radius: 8px;
    // &:hover {
    //   border-color: #dfe1e6;
    // }
    p {
      font-size: 12px;
      color: var(--para-text);
      letter-spacing: 0.01em;
      text-align: center;
      font-family: var(--sf-pro-text);
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      span {
        font-weight: 600;
      }
      &.ant-upload-drag-icon {
        display: table;
        margin: 0 auto 10px;
        padding: 11px 13px;
        background-color: #f3f2f1;
        line-height: 1;
        border-radius: 8px;
      }
    }
  }
  .ant-upload-drag-container {
    > div {
      border: 2px dashed #dfe1e6;
      background-color: var(--form-element-bg);
      border-radius: 8px;
      padding: 16px 0;
    }
    .uploadBtnFx {
      background-color: var(--theme-color);
      border-radius: 8px;
      padding: 10px 16px;
      display: table;
      p {
        line-height: 1.2;
        font-size: 14px;
        font-family: var(--sf-pro-display);
        letter-spacing: 0em;
      }
      span {
        margin: 0;
        font-weight: 400 !important;
        font-size: 14px;
        font-family: var(--sf-pro-display);
        letter-spacing: 0em;
      }
    }
  }
  .ant-upload-list-picture-container {
    border: 2px dashed #dfe1e6;
    background-color: var(--form-element-bg);
    border-radius: 8px;
  }
  .ant-upload.ant-upload-drag .ant-upload {
    padding: 0px;
  }
  .ant-upload.ant-upload-drag {
    border: none;
    margin-bottom: 15px;
  }
  .ant-upload-list-item-thumbnail {
    width: 170px;
    height: 65px;
    pointer-events: none;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .ant-upload-list-picture .ant-upload-list-item {
    border: none;
    margin: 0;
  }
  .ant-upload-list-picture-container .ant-tooltip,
  .ant-upload-list-item-name {
    display: none;
  }
  .ant-upload-list-picture-container {
    .ant-upload-span {
      justify-content: space-between;
    }
  }
  .csv-file .ant-upload-list-item-card-actions {
    &:after {
      content: "Remove File";
      right: 8px;
    }
  }
  .ant-upload-list-item-card-actions {
    position: relative;
    &:after {
      content: "Remove Logo";
      position: absolute;
      top: 17px;
      right: 0px;
      font-size: 12px;
      color: #605e5c;
      letter-spacing: 0.01em;
      font-family: var(--sf-pro-text);
      font-weight: 600;
    }
    &:before {
      content: "";
      position: absolute;
      top: 11px;
      left: 0px;
      background-image: url(${wrongIcon});
      width: 14px;
      height: 14px;
      background-repeat: no-repeat;
      background-size: contain;
    }
    button {
      width: 100px;
      svg {
        display: none;
      }
    }
    .ant-upload-list-item-card-actions-btn {
      z-index: 2;
    }
  }
  .ant-upload-list-item-card-actions.picture {
    top: 0;
    padding: 8px 0;
  }
  .ant-input[disabled],
  .ant-select-disabled {
    border-color: transparent !important;
  }
  .ant-select-disabled {
    .ant-select-selection-item {
      color: #091e42;
    }
    .ant-select-arrow {
      display: none;
    }
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
    background-color: transparent !important;
  }
  .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
    box-shadow: none !important;
  }
  .switchRadio {
    &.threeSwitch {
      .ant-radio-group-solid {
        label {
          width: 126px;
          &.ant-radio-button-wrapper-checked {
            &:last-child {
              border-left: 1px solid #e1dfdd;
            }
          }
        }
      }
    }
    &.twoSwitch {
      .ant-radio-group-solid {
        flex-grow: 1;
        display: flex;
        label {
          flex-grow: 0.5;
          &.ant-radio-button-wrapper-checked {
            &:last-child {
              border-left: 1px solid #e1dfdd;
            }
          }
        }
      }
    }

    &.extraWidth {
      .ant-radio-group-solid {
        label {
          width: 200px;
          &.ant-radio-button-wrapper-checked {
            &:last-child {
              border-left: 1px solid #e1dfdd;
            }
          }
        }
      }
    }

    &.toggleClassOrderCreation {
      .ant-radio-group-solid {
        label {
          width: 130px;
          &.ant-radio-button-wrapper-checked {
            &:last-child {
              border-left: 1px solid #e1dfdd;
            }
          }
        }
      }
    }

    &.csvStyle {
      .ant-radio-group-solid {
        label {
          &:last-child {
            border: 0.5px solid;
          }
        }
      }
    }

    .ant-radio-group-solid {
      border-radius: 8px;
      overflow: hidden;
      border: 0px;
      label {
        width: 120px;
        height: 40px;
        margin: 0;
        border: 1px solid #e1dfdd;
        background-color: #ffff !important;
        &:first-child {
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
        }
        &:last-child {
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
          border-left: 0px;
          &:before {
            background-color: #a19f9d;
          }
        }
        &.ant-radio-button-wrapper-checked {
          background-color: #f3f2f1 !important;
          border-color: #a19f9d;
          span {
            color: #605e5c !important;
          }
        }
        span:last-child {
          font-style: normal;
          color: #a19f9d;
          font-family: var(--sf-pro-text);
          text-align: center;
          display: table;
          margin: 0px auto;
          padding: 9px 0;
        }
      }
    }
  }
  .ant-radio-button-wrapper:focus-within {
    box-shadow: none;
  }
  .reverseCheckbox {
    .flexRowReverse {
      flex-direction: row-reverse;
      display: flex;
    }
    label {
      display: flex;
      flex-direction: column-reverse;
      height: 50px;
      padding-bottom: 10px;
      margin: 0px 5px;
      min-width: 70px;
      span {
        &:nth-of-type(1) {
          margin: 0 auto;
        }
        &:nth-of-type(2) {
          font-size: 12px;
          color: var(--black-color);
          font-family: var(--sf-pro-display-m);
          font-weight: 500;
          font-style: normal;
          text-align: center;
          margin-bottom: 3px;
          letter-spacing: 0.025em;
          margin: 0 auto;
        }
      }
    }
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: var(--theme-color);
    border-color: var(--theme-color);
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inne {
    border-color: var(--theme-color) !important;
  }
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: var(--theme-color) !important;
  }
  .titleVCenter {
    .boxFieldTitle {
      display: flex;
      label {
        align-self: center;
      }
    }
  }
  .imageShowed {
    justify-content: flex-end;
    display: flex;
    label {
      margin: 0px 5px;
      text-align: center;
      padding-bottom: 0px;
      span {
        &:nth-of-type(1) {
          padding-top: 7px;
        }
      }
    }
  }
  .paddingTB {
    > div {
      padding-top: 7px;
      padding-bottom: 7px;
    }
  }
  .ant-select-selection-placeholder {
    line-height: 36px !important;
  }
  .nonEditable {
    position: absolute;
    right: 15px;
    top: 10px;
    font-size: 14px;
    color: #a19f9d;
    font-family: var(--sf-pro-text);
  }
  .dBlock {
    display: block !important;
    .ant-form-item-label {
      label {
        color: var(--para-text);
        font-size: 14px;
        font-weight: 500;
        font-family: var(--sf-pro-text) !important;
        line-height: 1;
        height: 26px;
        padding: 0px 5px;
      }
    }
  }
  span.ant-input-affix-wrapper.ant-input-affix-wrapper-disabled {
    border: none;
    color: rgba(0, 0, 0, 0.25);
    background-color: #fafbfc;
    // border-color: #d9d9d9;
    box-shadow: none;
    cursor: not-allowed;
    border-radius: 8px;
    /* margin-left: 10px */
    /* margin-right: 10px; */
  }
  .ant-input-affix-wrapper
  {
    background-color: var(--form-element-bg);
    border: 2px solid #dfe1e6;
    box-sizing: border-box;
    border-radius: 8px;
    height: 45px;
    font-size: 14px;
    font-family: var(--sf-pro-text);
    box-shadow: none !important;
    &:hover,
      &:focus {
        outline: none !important;
        border-right-width: 2px !important;
        box-shadow: none !important;
        border-color:#DFE1E6 !important;
      }
      &.showErrorBorder {
        border-color: #ea655b !important;
      }
    
  }
  
  .errorText {
    color: #ea4e2c;
    font-size: 12px;
    line-height: 16px;
    font-family: var(--sf-pro-text);
  }
  .italicsTitleWithText {
    p {
      font-style: italic;
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      margin-top: 1px;
      color: #605e5c;
    }
  }
  .infoIcon {
    position: relative;
    top: 2px;
    width: 13px;
    height: 13px;
    background-image: url(${infoIcon});
    background-size: cover;
    background-repeat: no-repeat;
    display: inline-flex;
    margin-left: 4px;
    cursor: pointer;
  }
  .deliAddCollapseIcon {
    .ant-collapse-arrow svg {
      transition: transform 0.24s;
      position: absolute;
      margin-top: -44px;
    }
  }
  .planningDetailsCollapseIcon {
    .ant-collapse-arrow svg {
      transition: transform 0.24s;
      position: absolute;
      margin-top: -33px;
    }
  }
  .viewDropdownStyle {    
    margin-left: 20px !important;    
    }
  .innerMenuItem {
    margin-top: -10px;
    margin-bottom: -10px;
  }

  .pagination {
    display: flex;
    list-style: none;
    padding: 0;
    justify-content: flex-end;
    margin-top:9px;
  }

  .pagination li {
    // margin: 0 5px;
  }

  .pagination a {
    color: rgba(0, 0, 0, .85);
    text-decoration: none;
    padding: 8px 12px;
    border: 1px solid #ddd;
    font-size: 14px
    // border-radius: 4px;
  }
  
  .pagination a:hover {
    background-color: #f2f2f2;
  }

  .pagination .active a {
    background-color: rgb(243, 242, 241);
    color: rgb(234, 101, 91);
  }

  .prev-button-radius {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
  .next-button-radius {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .disabled {
    pointer-events: none;
    opacity: 0.5;
    // cursor: not-allowed;
  }

  .disabled:hover {
    cursor: url('data:image/svg+xml;utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8" fill="red" /></svg>'), auto;
  }

`;

export const TableStyle = styled.div`
  .ant-table-tbody > tr > td {
        padding: 0px 15px 7px 2px;
  }
  .ant-table-thead > tr > th {
    position: relative;
    // color: rgba(0, 0, 0, 0.85);
    color: var(--para-text);
    font-weight: 500;
    font-size: 14px;
    text-align: left;
    background: #fff;
    font-family: var(--sf-pro-text) !important;
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.3s ease;
  }
  .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    position: absolute;
    top: -23%;
    right: 0;
    width: 1px;
    height: 1.6em;
    // background-color: rgba(0, 0, 0, 0.06);
    transform: translateY(-50%);
    transition: background-color 0.3s;
    content: '';
}
    // color: var(--para-text);
    // font-size: 14px;
    // font-weight: 500;
    // font-family: var(--sf-pro-text) !important;
`;

export const DownArrowDraw = styled.div`
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 7px;
    height: 7px;
    z-index: 5;
    border-top: 2px solid #605e5c;
    border-right: 2px solid #605e5c;
    transform: rotate(135deg);
  }
`;
export const DropDownSearchDraw = styled.div`
  position: relative;
  &:before {
    content: "";
    position: absolute;
    top: -3px;
    left: -7px;
    width: 11px;
    height: 11px;
    z-index: 5;
    background-size: contain;
    background-repeat: no-repeat;
    background-image: url(${SearchIcon});
  }
`;
export const RightLayoutContainer = styled.div`
  height: 100%;
  padding: 0 36px;
  background-color: #ffffff;
  position: relative;
  padding-bottom: 55px;
  &.export {
    text-align: left;
  }
  .textTypeBtn {
    font-size: 14px;
    color: var(--theme-color);
    line-height: 16px;
    font-family: var(--sf-pro-display-m);
    box-shadow: none !important;
    border: none !important;
    padding: 5px 0px;
    margin: 0px 12px;
    &:after {
      box-shadow: none !important;
    }
    span {
      position: relative;
      &:after {
        content: "";
        position: absolute;
        bottom: -4px;
        left: 0px;
        width: 100%;
        height: 1px;
        background-color: var(--theme-color-hover);
        opacity: 0;
        transition: all 0.3s linear;
      }
    }
    &:hover {
      color: var(--theme-color-hover);
      span:after {
        opacity: 1;
      }
    }
  }

 .textTypeBtnForERP {
    font-size: 14px;
    color: var(--theme-color);
    line-height: 16px;
    font-family: var(--sf-pro-display-m);
    box-shadow: none !important;
    border: none !important;
    // padding: 5px 0px;
    // margin: 0px 12px;
    margin-top: -2px;
    &:after {
      box-shadow: none !important;
    }
    span {
      position: relative;
      &:after {
        content: "";
        position: absolute;
        bottom: -4px;
        left: 0px;
        width: 100%;
        height: 1px;
        background-color: var(--theme-color-hover);
        opacity: 0;
        transition: all 0.3s linear;
      }
    }
    &:hover {
      color: var(--theme-color-hover);
      span:after {
        opacity: 1;
      }
    }
  }

  .themeBtnForERP {
    min-width: 90px;
    border-radius: 8px;
    padding: 4px 18px;
    min-height: 36px;
    background-color: var(--theme-color);
    text-align: center;
    border: none !important;
    outline: none !important;
    margin: 0px 12px;
    svg {
      position: relative;
      top: 2px;
    }
    span {
      font-size: 14px;
      font-family: var(--sf-pro-display);
      color: #ffffff;
      line-height: 16px;
      text-align: center;
      margin-left: -1px;
      position: relative;
      top: -1px;
    }
    &:hover {
      background-color: var(--theme-color-hover);
    }
    &.noBg {
      background-color: transparent;
      border: 1px solid var(--theme-color) !important;
      span {
        color: var(--theme-color);
      }
      &.disabled {
        border: 1px solid #e5e5e5 !important;
        span {
          color: var(--light-text);
        }
      }
    }
    &.noMargin {
      span {
        margin: 0;
      }
    }
  }
  .themeBtn {
    min-width: 90px;
    border-radius: 8px;
    padding: 4px 18px;
    min-height: 36px;
    background-color: var(--theme-color);
    text-align: center;
    border: none !important;
    outline: none !important;
    margin: 0px 12px;
    svg {
      position: relative;
      top: 2px;
    }
    span {
      font-size: 14px;
      font-family: var(--sf-pro-display);
      color: #ffffff;
      line-height: 16px;
      text-align: center;
      margin-left: 10px;
      position: relative;
      top: -1px;
    }
    &:hover {
      background-color: var(--theme-color-hover);
    }
    &.noBg {
      background-color: transparent;
      border: 1px solid var(--theme-color) !important;
      span {
        color: var(--theme-color);
      }
      &.disabled {
        border: 1px solid #e5e5e5 !important;
        span {
          color: var(--light-text);
        }
      }
    }
    &.noMargin {
      span {
        margin: 0;
      }
    }
  }
  .noBgBtn {
    background-color: transparent;
    border-radius: 8px;
    padding: 4px 18px;
    min-height: 36px;
    text-align: center;
    margin-top: 30px;
    margin-right: 0;
    border: 1px solid var(--theme-color) !important;
    svg {
      position: relative;
      top: 2px;
    }
    span {
      font-size: 14px;
      font-family: var(--sf-pro-display);
      color: var(--theme-color);
      line-height: 16px;
      text-align: center;
      margin-left: 10px;
      position: relative;
      top: -1px;
    }
    &.disabled {
      border: 1px solid #e5e5e5 !important;
      span {
        color: var(--light-text);
      }
    }
  }
  .haberLogin {
    margin: 0;
  }
  .subTltFont .ant-page-header-heading-title {
    font-size: 20px !important;
  }
  .nonEditable {
    position: absolute;
    right: 15px;
    top: 10px;
    font-size: 14px;
    color: #a19f9d;
    font-family: var(--sf-pro-text);
  }
`;

export const DetailFields = styled.div`
  padding-bottom: 45px;
  p {
    font-size: 12px;
    line-height: 20px;
    font-family: var(--sf-pro-text);
    color: var(--para-text);
    margin: 0;
  }
  &.marginBtnP {
    p {
      margin-bottom: 12px;
    }
  }
  label {
    font-size: 16px;
    line-height: 20px;
    font-family: var(--sf-pro-display-m);
    color: var(--black-color);
    margin-bottom: 5px;
    span {
      font-size: 14px;
      font-style: italic;
      color: #8b8a88;
    }
  }
  .groupForm {
    border-bottom: 1px solid #edebe9;
  }
  .groupDetailWrap {
    .sub-category-newsol{
      width: 100%;
      // background-color: pink;
      // cursor: pointer;
      display: flex;
      // align-items: center;
      // justify-content: space-evenly;
      
      border: none;
      
      .ant-collapse-header{
        background: #ffffff;
        width:100%;
        padding: 5px 0px;
        .ant-collapse-header-text{
          color: black;
          font-size: 12px;
        }
        border: none;
      }
      .ant-collapse-item{
        padding: 0px;
        background: #ffffff;
        border: none;
        // span{
        //   color: black;
        //   font-size: 15px;  
        //   font-family: var(--sf-pro-display-m);
        // }
        // p{
        //   font-family: var(--sf-pro-text);
        //   font-size: 12px;
        //   // font-weight: 400;
        //   color: var(--para-text)
        // }
      }

      .ant-collapse-content-box{
        padding: 10px 0px
      }
    }
    .ant-row {
      input[type="text"],
      input[type="password"] {
        padding-left: 15px !important;
      }
      &.ant-form-item {
        margin-bottom: 0px;
      }
    }
    .centerAlign {
      align-self: center;
      width: 100%;
      border-bottom: 1px solid #edebe9;
      padding: 16px 0;
      > div {
        display: flex;
      }
      &:last-child {
        border-bottom: 0px;
      }
    }
  }
  .boxFieldTitle {
    padding-left: 25px;
  }
  .boxFormType {
    align-self: center;
    width: 100%;
    .ant-select {
      width: 100%;
    }
    &:last-child {
      margin-bottom: 0px !important;
    }
  }
  .blockBreak {
    display: block !important;
    .d-flex {
      display: flex;
      max-width: 100%;
      justify-content: space-between;
      > .boxFormType {
        flex: 0 0 49%;
        max-width: 49%;
        align-self: flex-start;
      }
      &.threeFields {
        > .boxFormType {
          flex: 0 0 35%;
          max-width: 35%;
        }

        .unitSelect {
          flex: 0 0 24%;
          max-width: 24%;
        }
      }
    }
    .d-flex1 {
      display: flex;
      justify-content: space-between;
      > .boxFormType {
        flex: 0 0 49%;
        max-width: 49%;
        align-self: flex-start;
      }
      &.threeFields {
        > .boxFormType {
          flex: 0 0 35%;
          max-width: 35%;
        }

        .unitSelect {
          flex: 0 0 24%;
          max-width: 24%;
        }
      }
    }
    .boxFormType {
      margin-bottom: 18px;
    }
  }
  .m-width {
    max-width: 100%;
  }
  .ant-row .ant-form-item-explain-error {
    /* min-height: 17px;
        bottom: -16px; */
    // Overlapping issue solved for error validate messages
    min-height: 0px;
    position: relative;
    bottom: -2px;
  }
  .mandatorySymbolColumnHeader {
    display: inline-block;
    margin-right: 4px;
    color: #ff4d4f;
    font-size: 14px;
    font-family: SimSun, sans-serif;
    line-height: 1;
    padding-top: 5px;
  }
  .columnHeader {
    color: var(--para-text);
    font-size: 14px;
    font-weight: 500;
    font-family: var(--sf-pro-text);
    line-height: 1;
    height: 26px;
  }
  .closeProdCutting {
    .ant-row {
      &.ant-form-item {
        margin-bottom: 1px;
      }
      &.ant-form-item-with-help {
        margin-bottom: 0px;
      }
    }
    .ant-form-item {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-variant: tabular-nums;
      line-height: 1.5715;
      list-style: none;
      font-feature-settings: 'tnum', "tnum";
      margin-bottom: 1px;
      vertical-align: top;
      transition: margin-bottom 0.3s 0.017s linear;
  }
  }
  .ant-tabs-content-holder{
    background-color:#ffffff;
  }
  .header {
    display:flex;
    align-items:center;
    justify-content:center;
    padding:2px;
    padding-bottom:5px;
  }
  .header > h3
  {
    font-size:19px;
    font-weight:bold;
  }.removeStar {
    .ant-form-item-label {
      label {
        &:before {
          display: none;
        }
        &:after {
          display: none;
        }
      }
    }
  }
  `;

export const RightLinkButton = styled.button`
 .linkButtonRight {
        padding: 0;
        font-size: 12px;
        color: #EA655B;
        text-decoration: none;
        background: none;
        border: none;
        cursor: pointer;
        position: absolute;
        top: 0;
        right: 0;
      }

      .linkButtonRight:hover {
        text-decoration: underline;
      }
`;

export const GroupTitle = styled.div`
  margin-top: 20px;
  h2 {
    font-size: 20px;
    line-height: 28px;
    font-family: var(--sf-pro-display-m);
    color: var(--black-color);
    margin-bottom: 5px;
  }
  p {
    margin-bottom: 10px;
  }
`;

export const PageTitleComp = styled.div`
  .ant-page-header {
    width: 100%;
    padding: 0 0px;
  }
  .fullWidth {
    width: 100vw;
  }
  .ant-page-header.POPageHeaderSize .ant-page-header-heading-title {
    font-size: 20px !important;
  }
  .ant-page-header-heading-title {
    color: var(--black-color);
    font-size: 28px;
    line-height: 36px;
    font-family: var(--sf-pro-display-m);
    font-weight: 500;
    margin: 0px;
  }
  display: flex;
  justify-content: space-between;
  position: sticky;
  padding: 16px 0;
  border-bottom: 1px solid #edebe9;
  .themeBtn {
    &:last-child {
      margin-right: 0px;
    }
  }
  .ant-page-header-heading-left {
    .ant-page-header-back {
      line-height: 1.5;
      margin-right: 28px;
    }
    .ant-page-header-back-button {
      &:before {
        content: "";
        position: absolute;
        top: 15px;
        left: 0px;
        width: 25px;
        height: 15px;
        background-image: url(${BackArrow});
        background-size: contain;
        background-repeat: no-repeat;
      }
      .anticon.anticon-arrow-left {
        display: none !important;
      }
    }
  }
  &.marginRightAdg {
    .themeBtn {
      margin-right: 0px;
    }
  }
  .styledSelect {
    margin-right: 12px;
    .ant-select-selector {
      border-radius: 8px!important;
      height: 35px!important;
      padding-block: 2px!important; 
    }
  }
`;

export const BackButtonHeader = styled.div`
  .ant-page-header-heading-left {
    .ant-page-header-back {
      margin-right: 0px;
    }
  }
`;

export const RightDrawerContainer = styled.div`
  padding: 10px 0;
  height: calc(100vh - 195px);
  overflow-y: scroll;
  padding-right: 16px;
  display: flex;
  flex-direction: column;
  .titleWithText {
    h5 {
      font-size: 16px;
      font-family: var(--sf-pro-display-m);
      color: #323130;
      line-height: 16px;
      margin-bottom: 4px;
    }
    h6 {
      font-size: 14px;
      font-family: var(--sf-pro-display-m);
      color: #323130;
      line-height: 16px;
      margin-top: 3px;
    }
    p {
      font-size: 12px;
      font-family: var(--sf-pro-text);
      color: var(--color-text-title);
      line-height: 20px;
    }
  }
  .subTitleWithText {
    p {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: #6b778c;
      margin-bottom: 4px;
      margin-top: 16px;
    }
  }
  .italicsTitleWithText {
    p {
      font-style: italic;
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      margin-top: 4px;
      color: #605e5c;
    }
  }
  .redTitleWithText {
    h3,
    p {
      color: #ea655b;
    }
    h3 {
      font-weight: 500;
      font-size: 18px;
    }
    p {
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
    }
  }
  .titlebytwo {
    h5 {
      font-size: 20px;
      margin-bottom: 15px;
    }
    p {
      margin-bottom: 5px;
    }
  }
  .dBlock {
    display: block !important;
    .ant-form-item-label {
      label {
        color: var(--para-text);
        font-size: 12px;
        font-family: var(--sf-pro-display-m);
        line-height: 1;
        height: 26px;
      }
    }
  }
  .removeStar {
    .ant-form-item-label {
      label {
        &:before {
          display: none;
        }
        &:after {
          display: none;
        }
      }
    }
  }
  .haberSignup {
    margin-top: 15px;
  }
  .themeBtn {
    min-width: 90px;
    border-radius: 8px;
    padding: 4px 18px;
    min-height: 36px;
    background-color: var(--theme-color);
    text-align: center;
    border: none !important;
    outline: none !important;
    margin: 0px 12px;
    svg {
      position: relative;
      top: 2px;
    }
    span {
      font-size: 14px;
      font-family: var(--sf-pro-display);
      color: #ffffff;
      line-height: 16px;
      text-align: center;
      margin-left: 10px;
      position: relative;
      top: -1px;
    }
    &:hover {
      background-color: var(--theme-color-hover);
    }
    &.noBg {
      background-color: transparent;
      border: 1px solid var(--theme-color) !important;
      span {
        color: var(--theme-color);
      }
    }
  }
  .buttonFlex {
    display: flex;
    .themeBtn {
      margin: 0px 10px;
      &:nth-of-type(1) {
        margin-left: 0px;
      }
    }
    &.fixedBtm {
      background-color: #ffffff;
      position: absolute;
      bottom: 55px;
      width: 100%;
      left: 0px;
      padding: 15px 24px 20px;
      border-top: 1px solid #edebe9;
      > div {
        margin: 0 !important;
      }
    }
  }
  .drawerField {
    padding: 19px 0 0px;
    border-bottom: 1px solid #edebe9;
  }
  .removePadLeft {
    .haberLogin .ant-row input[type="text"] {
      padding-left: 16px !important;
    }
  }
  .inputPadLeft {
    .haberLogin .ant-row input[type="text"] {
      padding-left: 4px !important;
    }
  }
  .textTypeBtn {
    font-size: 14px;
    color: var(--theme-color);
    line-height: 16px;
    font-family: var(--sf-pro-display-m);
    box-shadow: none !important;
    border: none !important;
    padding: 5px 0px;
    margin: 0px 12px;
    &:after {
      content: "";
      position: absolute;
      bottom: 4px;
      left: 0px;
      width: 100%;
      height: 1px;
      background-color: var(--theme-color-hover);
      opacity: 0;
      transition: all 0.3s linear;
    }
    &:hover {
      color: var(--theme-color-hover);
      &:after {
        opacity: 1;
      }
    }
  }
  .specialBtn {
    button.noMargin {
      span {
        margin-left: 0px;
      }
    }
    .blackTxt {
      border-radius: 8px;
      padding: 3px 10px;
      height: 32px;
      span {
        color: var(--main-title);
        transition: all 0.2s linear;
      }
    }
  }
  .adjCntBtn {
    display: flex;
    justify-content: flex-end;
    .textTypeBtn {
      align-self: center;
    }
  }
  .dFlex {
    display: flex;
  }
  .blackTxt {
    margin-right: 2px;
    &:after {
      display: none;
    }
    &:hover {
      background-color: #fdf0ef;
      color: var(--theme-color);
      span {
        color: var(--theme-color);
      }
    }
  }
  .qualityToggled {
    background-color: #fff;
    &.openHeight {
      height: auto;
      transition: height 0.26s ease;
    }
    &.closeHeight {
      height: 32px;
      transition: height 0.26s ease;
    }
    .closeQuality {
      opacity: 0;
      transform: scaleY(0);
      transform-origin: top;
      transition: transform 0.26s ease;
    }
    .openQuality {
      opacity: 1;
      transform: scaleY(1);
      transform-origin: top;
      transition: transform 0.26s ease;
    }
  }
  .xtraText {
    h3 {
      font-size: 20px;
      font-family: var(--sf-pro-display-m);
      margin: 0px;
    }
    p {
      margin-bottom: 16px;
    }
  }
  .qualityInfo {
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    color: var(--para-text);
    line-height: 16px;
    &.It {
      font-style: italic;
    }
  }
  .qualityRow {
    .boxFieldTitle {
      padding-left: 0px;
    }
  }
  .centerAlignBtn {
    button {
      align-self: center;
    }
    .deleteQtyBtn {
      margin: 0 !important;
      margin-left: 7px !important;
      right: 0px !important;
      top: 0 !important;
    }
  }
  .selectForm .ant-form-item-control {
    height: 40px;
  }
  .justifyCSBetween {
    justify-content: space-between;
  }
  .ant-row [disabled] {
    background-color: #f3f2f1 !important;
    border-color: #dfe1e6 !important;
  }

  .labelSel {
    color: var(--para-text);
    font-size: 12px;
    font-family: var(--sf-pro-display-m);
    line-height: 2;
    height: 20px !important;
    display: block;
  }
  .drawerField.removeStar {
    label {
      height: 16px;
    }
  }
`;

export const TableLayoutData = styled.div`
  table {
    border: 1px solid #eeeeee;
    border-bottom: 0px;
    border-top: 0px;
    min-width: 100% !important;
    .ant-table-tbody > tr > td {
      padding: 3px 16px;
      font-size: small;
      font-family: var(--sf-pro-text);
      color: var(--para-text);
      line-height: 16px;
    }
    /* .ant-table-tbody > tr > td {
      padding: 0px 7px !important;
    } */
    .ant-skeleton.ant-skeleton-element.ant-skeleton-active{
      width: 100% !important;
    }
    .ant-skeleton-content .ant-skeleton-title {
      height: 15px !important;
      margin-top: 0px !important;
    }
    .ant-table-column-title,
    thead .ant-table-cell {
      font-size: 12px;
      font-family: var(--sf-pro-display-m);
      color: var(--para-text);
      line-height: 16px;
      text-transform: uppercase;
    }
    thead th.ant-table-cell {
      padding: 6px 16px;
      background-color: #faf9f8;
    }
    .ant-table-column-sorters {
      justify-content: unset;
    }
    .ant-table-column-title {
      flex: none;
      margin-right: 4px;
    }
    .ant-table-selection-column {
      text-align: left !important;
  }
    .ant-table-tbody > tr > td {
      
      .ant-checkbox-checked .ant-checkbox-inner {
        background-color: var(--theme-color);
        border-color: var(--theme-color);
      }
      .ant-checkbox-wrapper:hover .ant-checkbox-inne {
        border-color: var(--theme-color) !important;
      }
      .ant-checkbox-wrapper:hover .ant-checkbox-inner,
      .ant-checkbox:hover .ant-checkbox-inner,
      .ant-checkbox-input:focus + .ant-checkbox-inner {
        border-color: var(--theme-color) !important;
      }
      border-bottom: 1px solid #e1dfdd;
    }
    thead {
      th {
        &:before {
          display: none;
        }
      }
    }
    .ant-table-measure-row > td {
      font-size: 0px !important;
      height: 0px !important;
    }
  }
  .userDataCell {
    display: flex;
    .userPimage {
      width: 35px;
      height: 35px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 8px;
      align-self: center;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .userBio {
      label {
        font-size: 14px;
        font-family: var(--sf-pro-display-m);
        color: #323130;
        line-height: 16px;
        span {
          font-size: 11px;
          font-family: var(--sf-pro-display-m);
          color: var(--para-text);
          line-height: 16px;
          background-color: #edebe9;
          border-radius: 10px;
          padding: 1px 8px;
          margin-left: 4px;
        }
      }
      P {
        font-size: 12px;
        font-family: var(--sf-pro-text);
        color: var(--para-text);
        line-height: 16px;
        margin: 0;
      }
    }
  }
  .actionBtn {
    display: flex;
    justify-content: center;
    button {
      border: 1px solid transparent !important;
      box-shadow: none !important;
      outline: none !important;
      padding: 5px 7px;
      display: flex;
      margin: 0px 3px;
      border-radius: 8px;
      transition: all 0.3s ease-in;
      &:hover {
        background-color: #f3f2f1;
        color: rgb(96, 94, 92);
      }
      svg {
        align-self: center;
      }
    }
    &.jumbo-roll-column {
      justify-content: flex-start;
    }
  }
  .ant-pagination {
    padding: 9px 16px 9px 0;
    position: relative;
    margin: 0;
    border: 0.5px solid #eeeeee;
    border-top: 0px;
    .ant-pagination-total-text {
      font-size: 12px;
      font-family: var(--sf-pro-display-m);
      color: var(--color-text-title);
      line-height: 16px;
      position: absolute;
      top: 16px;
      left: 16px;
    }
    .ant-pagination-item {
      border-right: 0px;
      a {
        font-size: 14px;
        font-family: var(--sf-pro-display-m);
      }
      &:hover {
        a {
          color: #605e5c;
        }
      }
      &.ant-pagination-item-active {
        border-color: #dad9d8;

        a {
          color: #ea655b;
          background-color: #f3f2f1;
        }
      }
    }
    .ant-pagination-item,
    .ant-pagination-prev {
      margin: 0;
      border-color: #dad9d8;
      border-radius: 0 !important;
    }
    .ant-pagination-prev,
    .ant-pagination-next {
      min-width: 50px;
      &:hover button {
        color: #605e5c;
        border-color: #d9d9d9 !important;
      }
      &.ant-pagination-disabled {
        color: var(--para-text);
      }
      button {
        position: relative;
        &:after {
          position: absolute;
          top: 0px;
          left: 10px;
          font-size: 14px;
        }
        span {
          svg {
            display: none;
          }
        }
      }
    }
    .ant-pagination-prev {
      button {
        border-right: 0px;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
        &:after {
          content: "Prev";
        }
      }
    }
    .ant-pagination-next {
      button {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
        &:after {
          content: "Next";
        }
      }
    }
  }
  .ant-progress-text {
    display: none;
  }
  .statusVal[dataval="Disabled"],
  .statusVal[dataval="Deactive"],
  .statusVal[dataval="On Hold"],
  .statusVal[dataval="Rejected"],
  .statusVal[dataval="Cancelled"] {
    color: #ea4e2c;
    background-color: #fdeeea;
    padding: 4px 7px;
    border-radius: 8px;
    display: table;
    margin: 0 auto;
  }
  .statusVal[dataval="Active"],
  .statusVal[dataval="Approved"],
  .statusVal[dataval="Closed"],
  .statusVal[dataval="Produced"],
  .statusVal[dataval="Complete"],
  .statusVal[dataval="In Production"] {
    color: #107c10;
    background-color: #ecf9f0;
    padding: 4px 7px;
    border-radius: 8px;
    display: table;
    margin: 0 auto;
  }
  .statusVal[dataval="Changes Req"] ,
  .statusVal[dataval="Changes Requested"]{
    color: #cd9436;
    background-color: #fef5e6;
    padding: 4px 7px;
    border-radius: 8px;
    display: table;
    margin: 0 auto;
  }
  .statusVal[dataval="Pending"],
  .statusVal[dataval="Pending Confirmation"],
  .statusVal[dataval="Mapped"],
  .statusVal[dataval="In Progress"] {
    color: #3485e0;
    background-color: #e3effc;
    padding: 4px 7px;
    border-radius: 8px;
    display: table;
    margin: 0 auto;
  }
  .statusVal[dataval="Open"],
  .statusVal[dataval="Provisional"],
  .statusVal[dataval="Not Mapped"],
  .statusVal[dataval="Merged"] {
    color: #6a6866;
    background-color: #edebe9;
    padding: 4px 7px;
    border-radius: 8px;
    display: table;
    margin: 0 auto;
  }

  .ant-table-tbody .ant-table-cell.ant-table-cell-fix-left {
    .ant-table-cell-fix-left-last {
      border-right: 2px solid #e1e1e1;
      &:after {
        box-shadow: none !important;
      }
    }
  }
  .ant-table-ping-left .ant-table-cell-fix-left-last::after {
    box-shadow: none !important;
    border: 1px double #e1e1e1;
    width: 3px;
    border-top: 0;
    border-bottom: 0px;
    background-color: #ffffff;
  }
  .ant-table-ping-right:not(.ant-table-has-fix-right)
    .ant-table-container::after {
    box-shadow: none !important;
    border-right: 1px solid #eeeeee;
  }
  tr.ant-table-row.true {
    background-color: #fdf0ef !important;
    td.ant-table-cell-fix-left {
      background-color: #fdf0ef !important;
    }
    &:hover td {
      background-color: #fdf0ef !important;
    }
  }
  tr.ant-table-row.check {
    background-color: #e6f7ff !important;
    td.ant-table-cell-fix-left {
      background-color: #e6f7ff !important;
    }
    &:hover td {
      background-color: #e6f7ff !important;
    }
  }
  .infoIcon {
    position: relative;
    top: 2px;
    width: 13px;
    height: 13px;
    background-image: url(${infoIcon});
    background-size: cover;
    background-repeat: no-repeat;
    display: inline-flex;
    margin-left: 4px;
    cursor: pointer;
  }
  .removePagnation .ant-pagination {
    display: none;
  }
  .multiCoreContainer{
    display: flex;
    width: 300px;
    gap: 10px;
    align-items:center;
    margin-left: 40%;
    transform: translateY(-57px);
    width: 50%;
    .coreIdText {
      // padding-left: 20px;
      // margin-top: 10px;
      color: var(--para-text);
      font-family: var(--sf-pro-text);
      font-size: 14px;
    }
  }
`;

export const JobCardContainer = styled.div`
  flex-grow: 1;
  outline: none;
  overflow-y: auto;
  position: relative;
  height: calc(100vh - 115px);
  .jobGutter {
    height: 100%;
  }
  .cardMainGroup {
    display: flex;
    flex-direction: column;
    height: 100%;
    margin-right: 0;
    position: relative;
    .board-canvas {
      flex-grow: 1;
      position: relative;
      margin-top: 16px;
    }
  }
  .cardGroup {
    bottom: 0;
    left: 0;
    margin-bottom: 8px;
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 8px;
    position: absolute;
    right: 0;
    top: 0;
    -webkit-user-select: none;
    user-select: none;
    white-space: nowrap;
  }
`;

export const JobListColumn = styled.div`
  box-sizing: border-box;
  display: inline-block;
  height: 100%;
  margin: 0 6px;
  vertical-align: top;
  white-space: nowrap;
  width: ${window.screen.width < 1500 ? "250px" : window.screen.width < 1800 ? "290px" : "328px"};
  background-color: #faf9f8;
  border-radius: 8px;
  .jobListWrap {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    max-height: 100%;
    position: relative;
    white-space: normal;
  }
  .cardRollers {
    flex: 1 1 auto;
    margin: 8px 4px;
    min-height: 0;
    // overflow-x: hidden;
    // overflow-y: auto;
    padding: 4px 4px;
    z-index: 1;
    .ant-card-body {
      padding: 12px;
    }
    .ant-card-bordered {
      border-color: #f9f9f9;
      margin-bottom: 12px;
      border-radius: 8px;
      cursor: pointer;
    }
  }
  .jbCardHeader {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    h5,
    span {
      font-family: var(--sf-pro-display-m);
      font-size: 14px;
      color: var(--black-color);
      align-self: center;
      margin: 0;
    }
    span {
      display: flex;
    }
    span > svg {
      align-self: center;
      margin-right: 5px;
    }
  }
  .ant-card-body{
    padding: 10px;
  }
  .jbCardBody {
    padding: 10px 0 12px;
    cursor: pointer;
    ul {
      padding: 0;
      margin: 0;
      li {
        font-family: var(--sf-pro-display-m);
        font-size: 12px;
        color: var(--para-text);
        line-height: 20px;
        list-style: none;
      }
    }
  }
  .jbCardFooter {
    cursor: pointer;
    display: flex;
    > div {
      align-self: center;
    }
    .jbCreater {
      width: 26px;
      height: 26px;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 9px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    span {
      position: relative;
      padding: 0 8px 0 18px;
      font-family: var(--sf-pro-display-m);
      font-size: 12px;
      color: var(--para-text);
      &:before {
        content: "";
        position: absolute;
        top: 0px;
        left: 0px;
        background-size: contain;
        background-repeat: no-repeat;
        width: 15px;
        height: 15px;
      }
    }
    .date {
      &:before {
        background-image: url(${calendar});
        width: 13px;
        top: 1px;
        height: 13px;
      }
    }
    .time {
      padding-left: 15px;
      &:before {
        background-image: url(${clock});
        top: 1px;
      }
    }
  }
  .actionBtn {
    display: flex;
    justify-content: center;
    button {
      border: 1px solid transparent !important;
      box-shadow: none !important;
      outline: none !important;
      padding: 6px 7px;
      display: flex;
      margin: -4px -8px;
      border-radius: 8px;
      transition: all 0.3s ease-in;
      // &:hover {
      //   background-color: #f3f2f1;
      //   color: rgb(96, 94, 92);
      // }
      svg {
        align-self: center;
      }
    }
    &.jumbo-roll-column {
      justify-content: flex-start;
    }
  }
`;

export const JobCardHeader = styled.div`
  flex: 0 0 auto;
  min-height: 40px;
  padding: 10px 8px;
  position: relative;
  border: 1px solid #d2d0ce;
  background-color: #ffffff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  h4 {
    font-family: var(--sf-pro-display-m);
    font-size: 14px;
    color: var(--black-color);
    align-self: center;
    text-align: center;
    margin: 0;
  }
  &.pending-for-approval {
    border-bottom: 1px solid #0268d9;
  }
  &.rejected-job-cards {
    border-bottom: 1px solid #ea4e2c;
  }
  &.approved-job-cards {
    border-bottom: 1px solid #3fbd61;
  }
  &.in-production {
    border-bottom: 1px solid #ee9500;
  }
  &.completed-job-cards {
    border-bottom: 1px solid #3fbd61;
  }
`;
export const ContentMiddle = styled.div`
  display: flex;
  height: calc(100vh - 193px);
  .imageAnimate {
    justify-content: center;
    align-self: center;
    margin: 0 auto;
  }
  .imageCover {
    width: 500px;
    height: 350px;
    p {
      font-size: 14px;
      font-family: var(--sf-pro-text);
      color: var(--para-text);
      line-height: 20px;
      text-align: center;
      padding-top: 40px;
    }
  }
`;

export const ResultWrap = styled.div`
  .leftPostTab {
    .ant-tabs-nav {
      border-right: 1px solid #ebebeb;
    }
    .ant-tabs-nav-wrap {
      .ant-tabs-nav-list {
        background-color: #faf9f8;
      }
      .ant-tabs-tab {
        margin-top: 2px;
        padding: 5px 24px;
        color: #a19f9d;
        font-size: 14px;
        font-family: var(--sf-pro-display);
        &.ant-tabs-tab-active {
          background-color: #fff;
          .ant-tabs-tab-btn,
          .ant-tabs-tab-btn:focus,
          .ant-tabs-tab-btn:active {
            color: #ea655b !important;
          }
        }
      }
      .ant-tabs-ink-bar {
        background: #ea655b;
        right: auto;
        left: 0;
      }
    }
  }
  .topPostTab {
    .ant-tabs-nav {
      margin-bottom: 5px;
      border-right: 0;
    }
    .ant-tabs-tabpane {
      > div {
        .themeBtn {
          min-height: 32px;
        }
      }
    }
    .ant-page-header-heading-title {
      font-size: 18px;
      line-height: 20px;
    }
    .ant-tabs-nav-wrap {
      .ant-tabs-nav-list {
        background-color: transparent;
      }
      .ant-tabs-tab {
        padding: 5px 10px;
        margin-left: 12px;

        &:nth-of-type(1) {
          margin-left: 0px;
        }
        &.ant-tabs-tab-active {
          .ant-tabs-tab-btn,
          .ant-tabs-tab-btn:focus,
          .ant-tabs-tab-btn:active {
            color: #ea655b !important;
          }
        }
      }
    }
  }
  .lossValue {
    margin-top: 10px;
    > .ant-row {
      justify-content: space-between;
    }
    .ant-col {
      flex: 0 0 49%;
      max-width: 49%;
    }
    .summaryValue {
      background-color: #f3f5f9;
      padding: 12px 10px;
      border-radius: 8px;
      margin-bottom: 10px;

      .lesserSolution {
        font-family: var(--sf-pro-display-m);
        font-style: normal;
        font-weight: normal;
        font-size: 12px !important;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #605e5c;
        svg {
          margin: 0px 4px;
        }
      }
      h5 {
        font-size: 14px;
        line-height: 24px;
        font-family: var(--sf-pro-display-m);
        color: #000000;
        position: relative;
        padding-left: 34px;
        span {
          width: 24px;
          height: 24px;
          border-radius: 8px;
          background-color: #ea655b;
          margin-right: 8px;
          display: inline-block;
          position: absolute;
          left: 0;
          top: 0;
          &:after {
            content: "";
            position: absolute;
            width: 16px;
            height: 16px;
            background-size: contain;
            background-repeat: no-repeat;
          }
          &.trimCut:after {
            top: 4px;
            left: 4px;
            background-image: url(${cutter});
          }
          
          &.trimCutGray:after {
            top: 4px;
            left: 4px;
            background-image: url(${cutterGray});
          }
          &.trimBox:after {
            top: 6px;
            left: 6px;
            width: 13px;
            height: 13px;
            background-image: url(${openBox});
          }
        }
      }
      span {
        display: block;
        font-size: 24px;
        line-height: 32px;
        font-family: var(--sf-pro-display-m);
        color: #000000;
      }
      label {
        display: block;
        font-size: 12px;
        line-height: 20px;
        font-family: var(--sf-pro-text);
        color: var(--para-text);
        padding-left: 0px;
        margin-top: 7px;
        margin-bottom: 0;
        img {
          position: relative;
          top: -1px;
        }
      }
    }
    .summaryValueCancelled {
      opacity: 0.65;
      background-color: #f3f5f9;
      padding: 12px 10px;
      border-radius: 8px;
      margin-bottom: 10px;
      .lesserSolution {
        font-family: var(--sf-pro-display-m);
        font-style: normal;
        font-weight: normal;
        font-size: 12px !important;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #605e5c;
        svg {
          margin: 0px 4px;
        }
      }
      h5 {
        font-size: 14px;
        line-height: 24px;
        font-family: var(--sf-pro-display-m);
        color: #000000;
        position: relative;
        padding-left: 34px;
        span {
          width: 24px;
          height: 24px;
          border-radius: 8px;
          background-color: #ea655b;
          margin-right: 8px;
          display: inline-block;
          position: absolute;
          left: 0;
          top: 0;
          &:after {
            content: "";
            position: absolute;
            width: 16px;
            height: 16px;
            background-size: contain;
            background-repeat: no-repeat;
          }
          &.trimCut:after {
            top: 4px;
            left: 4px;
            background-image: url(${cutter});
          }
          &.trimBox:after {
            top: 6px;
            left: 6px;
            width: 13px;
            height: 13px;
            background-image: url(${openBox});
          }
        }
      }
      span {
        display: block;
        font-size: 24px;
        line-height: 32px;
        font-family: var(--sf-pro-display-m);
        color: #000000;
      }
      label {
        display: block;
        font-size: 12px;
        line-height: 20px;
        font-family: var(--sf-pro-text);
        color: var(--para-text);
        padding-left: 0px;
        margin-top: 7px;
        margin-bottom: 0;
        img {
          position: relative;
          top: -1px;
        }
      }
    }
    ul {
      padding: 0px;
      margin: 0;
      li {
        list-style: none;
        padding: 9px 0;
        span {
          display: block;
          font-size: 16px;
          line-height: 20px;
          font-family: var(--sf-pro-display-m);
          color: var(--black-color);
          margin-bottom: 6px;
        }
        p {
          font-size: 12px;
          line-height: 20px;
          font-family: var(--sf-pro-text);
          color: var(--para-text);
          margin: 0;
        }
      }
    }
    .alertmsd {
      h4 {
        font-size: 16px;
        line-height: 20px;
        font-family: var(--sf-pro-display-m);
        color: var(--black-color);
        margin-bottom: 15px;
        padding-top: 9px;
      }
    }
    .sub-category{
      width: 100%;
      // background-color: pink;
      cursor: pointer;
      display: flex;
      // align-items: center;
      // justify-content: space-evenly;
      
      border: none;
      
      .ant-collapse-header{
        background: #ffffff;
        width:100%;
        padding: 5px 0px;
        .ant-collapse-header-text{
          color: black;
          font-size: 12px;
        }
        border: none;
      }
      .ant-collapse-item{
        padding: 0px;
        background: #ffffff;
        border: none;
        span{
          color: black;
          font-size: 15px;  
          font-family: var(--sf-pro-display-m);
        }
        p{
          font-family: var(--sf-pro-text);
          font-size: 12px;
          // font-weight: 400;
          color: var(--para-text)
        }
      }

      .ant-collapse-content-box{
        padding: 10px 0px
      }
    }
  }
`;

export const ResultWrap1 = styled.div`
  .leftPostTab {
    .ant-tabs-nav-wrap {
      .ant-tabs-tab {
        margin-top: 2px;
        padding: 5px 24px;
        color: #a19f9d;
        font-size: 14px;
        font-family: var(--sf-pro-display);
        &.ant-tabs-tab-active {
          background-color: #fff;
          .ant-tabs-tab-btn,
          .ant-tabs-tab-btn:focus,
          .ant-tabs-tab-btn:active {
            color: #ea655b !important;
          }
        }
      }
      .ant-tabs-ink-bar {
        background: #ea655b;
        right: auto;
        left: 0;
      }
    }
  }
  .topPostTab {
    .ant-tabs-nav {
      margin-bottom: 5px;
      border-right: 0;
    }
    .ant-tabs-tabpane {
      > div {
        .themeBtn {
          min-height: 32px;
        }
      }
    }
    .ant-page-header-heading-title {
      font-size: 18px;
      line-height: 20px;
    }
    .ant-tabs-nav-wrap {
      .ant-tabs-nav-list {
        background-color: transparent;
      }
      .ant-tabs-tab {
        padding: 5px 10px;
        margin-left: 12px;

        &:nth-of-type(1) {
          margin-left: 0px;
        }
        &.ant-tabs-tab-active {
          .ant-tabs-tab-btn,
          .ant-tabs-tab-btn:focus,
          .ant-tabs-tab-btn:active {
            color: #ea655b !important;
          }
        }
      }
    }
  }
  .lossValue {
    margin-top: 10px;
    > .ant-row {
      justify-content: space-between;
    }
    .ant-col {
      flex: 0 0 49%;
      max-width: 49%;
    }
    .summaryValue {
      background-color: #f3f5f9;
      padding: 12px 10px;
      border-radius: 8px;
      margin-bottom: 10px;

      .lesserSolution {
        font-family: var(--sf-pro-display-m);
        font-style: normal;
        font-weight: normal;
        font-size: 12px !important;
        line-height: 20px;
        display: flex;
        align-items: center;
        color: #605e5c;
        svg {
          margin: 0px 4px;
        }
      }
      h5 {
        font-size: 14px;
        line-height: 24px;
        font-family: var(--sf-pro-display-m);
        color: #000000;
        position: relative;
        padding-left: 34px;
        span {
          width: 24px;
          height: 24px;
          border-radius: 8px;
          background-color: #ea655b;
          margin-right: 8px;
          display: inline-block;
          position: absolute;
          left: 0;
          top: 0;
          &:after {
            content: "";
            position: absolute;
            width: 16px;
            height: 16px;
            background-size: contain;
            background-repeat: no-repeat;
          }
          &.trimCut:after {
            top: 4px;
            left: 4px;
            background-image: url(${cutter});
          }
          &.trimBox:after {
            top: 6px;
            left: 6px;
            width: 13px;
            height: 13px;
            background-image: url(${openBox});
          }
        }
      }
      span {
        display: block;
        font-size: 24px;
        line-height: 32px;
        font-family: var(--sf-pro-display-m);
        color: #000000;
      }
      label {
        display: block;
        font-size: 12px;
        line-height: 20px;
        font-family: var(--sf-pro-text);
        color: var(--para-text);
        padding-left: 0px;
        margin-top: 7px;
        margin-bottom: 0;
        img {
          position: relative;
          top: -1px;
        }
      }
    }
    ul {
      padding: 0px;
      margin: 0;
      li {
        list-style: none;
        padding: 9px 0;
        span {
          display: block;
          font-size: 16px;
          line-height: 20px;
          font-family: var(--sf-pro-display-m);
          color: var(--black-color);
          margin-bottom: 6px;
        }
        p {
          font-size: 12px;
          line-height: 20px;
          font-family: var(--sf-pro-text);
          color: var(--para-text);
          margin: 0;
        }
      }
    }
    .alertmsd {
      h4 {
        font-size: 16px;
        line-height: 20px;
        font-family: var(--sf-pro-display-m);
        color: var(--black-color);
        margin-bottom: 15px;
        padding-top: 9px;
      }
    }
  }
  .sub-category{
    width: 100%;
    // background-color: pink;
    cursor: pointer;
    display: flex;
    // align-items: center;
    // justify-content: space-evenly;
    
    border: none;
    
    .ant-collapse-header{
      background: #ffffff;
      width:100%;
      padding: 5px 0px;
      .ant-collapse-header-text{
        color: black;
        font-size: 12px;
      }
      border: none;
    }
    .ant-collapse-item{
      padding: 0px;
      background: #ffffff;
      border: none;
      span{
        color: black;
        font-size: 15px;  
        font-family: var(--sf-pro-display-m);
      }
      p{
        font-family: var(--sf-pro-text);
        font-size: 12px;
        // font-weight: 400;
        color: var(--para-text)
      }
    }

    .ant-collapse-content-box{
      padding: 10px 0px
    }
  }

`;

export const PipeDesign = styled.div`
  padding: 10px 0;
  // text-align: center;
  background-color: #ffffff;
  // background-color: #FAF9F8;
  // padding:10px 5px;
  // .ant-cylinder-dark {
  // 	position: relative;
  // 	overflow: hidden;
  // 	width: 50px;
  // 	height: 50px;
  // 	left: -23px;
  // 	border-radius: 25px/50px;
  // 	background-color: #FB967F;
  // }
  // .ant-cylinder-dark:after {
  // 	content: "";
  // 	position: absolute;
  // 	height: 50px;
  // 	width: 25px;
  // 	right: -24px;
  // 	border-radius: 25px/50px;
  // 	-webkit-box-shadow: -24px 0 0 0 #A1A1A1;
  // }
  // .ant-cylinder-light {
  // 	position: relative;
  // 	overflow: hidden;
  // 	width: 50px;
  // 	height: 50px;
  // 	left: -23px;
  // 	border-radius: 25px/50px;
  // 	background-color: #FBE0DE;
  // }
  // .ant-cylinder-light:after {
  // 	content: "";
  // 	position: absolute;
  // 	height: 50px;
  // 	width: 25px;
  // 	right: -22px;
  // 	border-radius: 25px/50px;
  // 	-webkit-box-shadow: -22px 0 0 0 #A1A1A1;
  // }
  // .ant-cylinder-light:hover{
  //   background-color: #F9D1CE;
  // }
  // .ant-cylinder-white {
  // 	position: relative;
  // 	overflow: hidden;
  // 	width: 50px;
  // 	height: 50px;
  // 	left: -23px;
  // 	border-radius: 25px/50px;
  // 	background-color: #ffffff;
  // }
  // .ant-cylinder-white:after {
  // 	content: "";
  // 	position: absolute;
  // 	height: 50px;
  // 	width: 25px;
  // 	right: -32px;
  // 	border-radius: 25px/50px;
  // 	-webkit-box-shadow: -24px 0 0 0 #EEEEEE;
  // }
  .ant-pipe-container {
    // width: 620px;
    //width: 564px !important;
    height: 60px;
    border-radius: 25px/50px;
    position: relative;
    margin-bottom: 5px;
    display: flex;
    //justify-content: center;
    align-items: center;
  }
  // .ant-roll-child {
  //     float: left;
  //     padding: 0px;
  // }
  // .ant-roll-child-end{
  //   position:absolute;
  //   right:10px;
  //   top:9px;
  // }
  // .ant-roll-child-end, .ant-roll-child-end p {
  //     padding: 0px;
  // 	font-size: 10px;
  // 	padding-top: 0px;
  //   font-family:var(--sf-pro-display-m);
  //   color:var(--para-text);
  //   font-style:italic;
  // }

  .main-container {
    // margin: auto;
    position: relative;
    // overflow: hidden;
    height: 50%;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    background-color: #faf9f8;
  }
  .cylinder-dark {
    position: relative;
    display: inline-block;
    overflow: hidden;
    width: 50px;
    height: 60px;
    float: left;
    border-radius: 25px/60px;
    background-color: #fb967f;
  }
  .cylinder-dark-highlighted {
    position: relative;
    display: inline-block;
    overflow: hidden;
    width: 50px;
    height: 60px;
    float: left;
    border-radius: 25px/60px;
    background-color: #fb967f;
  }
  .cylinder-dark:after {
    content: "";
    position: absolute;
    display: inline-block;
    height: 60px;
    width: 25px;
    right: -25px;
    border-radius: 25px/60px;
    -webkit-box-shadow: -25px 0 0 0 #a2a2a2;
  }
  .cylinder-dark-last {
    position: relative;
    overflow: hidden;
    // width: 50px;
    height: 60px;
    float: left;
    border-radius: 25px/60px;
    background-color: #fb967f;
  }
  .cylinder-dark-last-highlighted {
    position: relative;
    overflow: hidden;
    // width: 50px;
    height: 60px;
    float: left;
    border-radius: 25px/60px;
    background-color: #fb967f;
  }
  .cylinder-dark-last:after {
    content: "";
    position: absolute;
    height: 60px;
    width: 25px;
    right: -32px;
    border-radius: 25px/60px;
    -webkit-box-shadow: -25px 0 0 0 #eeeeee;
  }
  .cylinder-dark-last-highlighted:after {
    content: "";
    position: absolute;
    height: 60px;
    width: 25px;
    right: -32px;
    border-radius: 25px/60px;
    -webkit-box-shadow: -25px 0 0 0 #eeeeee;
  }
  .cylinder-light {
    position: relative;
    overflow: hidden;
    // width: 50px;
    height: 60px;
    float: left;
    border-radius: 25px/60px;
    background-color: #fbe0de;
  }
  .cylinder-light-highlighted {
    position: relative;
    overflow: hidden;
    // width: 50px;
    height: 60px;
    float: left;
    border-radius: 25px/60px;
    background-color: #fbe0de;
  }
  .cylinder-light:after {
    content: "";
    position: absolute;
    height: 60px;
    // width: 25px;
    right: -25px;
    border-radius: 25px/60px; 
    width: 25px;
    -webkit-box-shadow: -25px 0 0 0 #a2a2a2;
  }
  .cylinder-light:hover {
    background-color: #f9d1ce;
  }
  .cylinder-light span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #605e5c;
  }
  .cylinder-light-highlighted span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #605e5c;
  }
  .cylinder-white span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #605e5c;
  }
  .cylinder-white-highlighted span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #605e5c;
  }
  .cylinder-dark span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #ffffff;
  }
  .cylinder-dark-highlighted span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #ffffff;
  }
  .cylinder-dark-last span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #ffffff;
  }
  .cylinder-dark-last-highlighted span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #ffffff;
  }
  // .cylinder-white span {
  //   display: none !important;
  // }
  .cylinder-light-last span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #605e5c;
  }
  .cylinder-light-last-highlighted span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #605e5c;
  }
  .cylinder-light-last {
    position: relative;
    overflow: hidden;
    // width: 50px;
    height: 60px;
    float: left;
    border-radius: 25px/60px; 
    background-color: #fbe0de;
  }
  .cylinder-light-last:hover {
    background-color: #f9d1ce;
  }
  .cylinder-light-last-highlighted {
    position: relative;
    overflow: hidden;
    // width: 50px;
    height: 60px;
    float: left;
    border-radius: 25px/60px; 
    background-color: #fbe0de;
  }
  .cylinder-light-last:after {
    content: "";
    position: absolute;
    height: 60px;
    width: 25px;
    right: -32px;
    border-radius: 25px/60px;
    -webkit-box-shadow: -25px 0 0 0 #eeeeee;
  }
  .cylinder-light-last-highlighted:after {
    content: "";
    position: absolute;
    height: 60px;
    width: 25px;
    right: -32px;
    border-radius: 25px/60px;
    -webkit-box-shadow: -25px 0 0 0 #eeeeee;
  }
  .cylinder-white {
    position: relative;
    overflow: hidden;
    // width: 50px;
    height: 60px;
    float: left; 
    border-radius: 25px/60px;
    background-color: #ffffff;
  }
  .cylinder-white-highlighted {
    position: relative;
    overflow: hidden;
    // width: 50px;
    height: 60px;
    float: left; 
    border-radius: 25px/60px;
    background-color: #ffffff;
  }
  .cylinder-white:after {
    content: "";
    position: absolute;
    height: 60px;
    width: 25px;
    right: -29px; 
    border-radius: 25px/60px;
    -webkit-box-shadow: -25px 0 0 0 #eeeeee;
  }
  .cylinder-white-highlighted:after {
    content: "";
    position: absolute;
    height: 60px;
    width: 25px;
    right: -29px; 
    border-radius: 25px/60px;
    -webkit-box-shadow: -25px 0 0 0 #eeeeee;
  }
  .cylinder-text {
    position: relative;
    overflow: hidden;
    font-size: 13px;
    float: right;
    padding-top: 4px;
    right: 20px;
    line-height: 18px;
  }
  span.cylinder-text p {
    // display: inline-flex !important;
    line-height: 18px;
  }
  .cylinder-stock-light {
    position: relative;
    overflow: hidden;
    // width: 50px;
    height: 60px;
    float: left;
    border-radius: 25px/60px;
    
    
    background-color: #fdf0ef;
  }
  .cylinder-stock-light-highlighted {
    position: relative;
    overflow: hidden;
    // width: 50px;
    height: 60px;
    float: left;
    border-radius: 25px/60px;
    
    
    background-color: #fdf0ef;
  }
  .cylinder-stock-light:after {
    content: "";
    position: absolute;
    height: 60px;
    width: 25px;
    right: -25px; 
    border-radius: 25px/60px;
    -webkit-box-shadow: -25px 0 0 0 #a2a2a2;
  }
  .cylinder-stock-light:hover {
    background-color: #f9d1ce;
  }
  .cylinder-stock-light span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #605e5c;
  }
  .cylinder-stock-light-highlighted span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #605e5c;
  }
  .cylinder-darkgray {
    position: relative;
    overflow: hidden;
    // width: 50px;
    height: 60px;
    float: left; 
    border-radius: 25px/60px;
    background-color: #E1DFDD;
  }
  .cylinder-darkgray-highlighted {
    position: relative;
    overflow: hidden;
    // width: 50px;
    height: 60px;
    float: left; 
    border-radius: 25px/60px;
    background-color: #E1DFDD;
  }
  .cylinder-darkgray:after {
    content: "";
    position: absolute;
    height: 60px;
    width: 25px; 
    right: -25px;
    border-radius: 25px/60px;
    -webkit-box-shadow: -25px 0 0 0 #a2a2a2;
  }
  .cylinder-darkgray:hover {
    background-color: #E1DFDD;
  }
  .cylinder-dark:hover {
    background-color: #EC746B;
  }
  .cylinder-darkgray span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    // color: #;
    color: #605e5c;
  }
  .cylinder-darkgray-highlighted span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    // color: #;
    color: #605e5c;
  }
  .cylinder-darkgray-last span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    // color: #;
    color: #605e5c;
  }
  .cylinder-darkgray-last-highlighted span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    // color: #;
    color: #605e5c;
  }
  .cylinder-darkgray-last {
    position: relative;
    overflow: hidden;
    // width: 50px;
    height: 60px;
    float: left;
    border-radius: 25px/60px;

    background-color: #E1DFDD;
  }
  .cylinder-darkgray-last-highlighted {
    position: relative;
    overflow: hidden;
    // width: 50px;
    height: 60px;
    float: left;
    border-radius: 25px/60px;

    background-color: #E1DFDD;
  }
  .cylinder-darkgray-last:after {
    content: "";
    position: absolute;
    height: 60px;
    width: 25px;
    right: -32px;
    border-radius: 25px/60px;
    -webkit-box-shadow: -25px 0 0 0 #eeeeee;
  }
  .cylinder-darkgray-last-highlighted:after {
    content: "";
    position: absolute;
    height: 60px;
    width: 25px;
    right: -32px;
    border-radius: 25px/60px;
    -webkit-box-shadow: -25px 0 0 0 #eeeeee;
  }
  .cylinder-stock-light-last span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #605e5c;
  }
  .cylinder-stock-light-last-highlighted span {
    font-family: var(--sf-pro-display);
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    color: #605e5c;
  }
  .cylinder-stock-light-last {
    position: relative;
    overflow: hidden;
    width: 50px;
    height: 60px;
    float: left;
    border-radius: 25px/60px;
    background-color: #fdf0ef;
  }
  .cylinder-stock-light-last:after {
    content: "";
    position: absolute;
    height: 60px;
    width: 25px;
    right: -32px;
    border-radius: 25px/60px;
    -webkit-box-shadow: -25px 0 0 0 #eeeeee;
  }
  .cylinder-stock-light-last-highlighted:after {
    content: "";
    position: absolute;
    height: 60px;
    width: 25px;
    right: -32px;
    border-radius: 25px/60px;
    -webkit-box-shadow: -25px 0 0 0 #eeeeee;
  }
`;
export const OtherPages = styled.div`
  .pageLeftGutter {
    height: 100%;
    position: relative;
  }
  .pageLeft_links {
    padding-left: 35px;

    border-left: 3px solid #e1dfdd;
    position: -webkit-sticky;
    position: sticky;
    top: 120px;
    span {
      display: table;
      padding: 12px 0;
      a {
        color: #a19f9d;
        font-size: 15px;
        font-family: var(--sf-pro-display-m);
        line-height: 16px;
        transition: all 0.2s ease-in;
        &:hover,
        &.active {
          color: #605e5c;
        }
      }
    }
  }
  .tcp-data {
    padding-right: 18%;
    h1 {
      color: #000000;
      font-size: 36px;
      font-family: var(--sf-pro-display-m);
      line-height: 44px;
      margin-top: 30px;
    }
    label {
      font-size: 14.5px;
      font-family: var(--sf-pro-text);
      color: #605e5c;
      line-height: 22px;
      letter-spacing: 0em;
      margin-bottom: 25px;
      display: block;
    }
    p {
      font-size: 14.5px;
      font-family: var(--sf-pro-text);
      color: #605e5c;
      line-height: 25px;
      letter-spacing: 0em;
      padding-bottom: 7px;
      b {
        font-weight: 600 !important;
      }
    }
  }
  .functional-btn {
    display: flex;
    justify-content: flex-end;
    margin-top: 40px;
    margin-right: -15px;
    button {
      span {
        margin: 0px;
        font-size: 15px;
      }
    }
  }
`;
export const FeedbackBoard = styled.div`
  h1 {
    color: #000000;
    font-size: 36px;
    font-family: var(--sf-pro-display-m);
    line-height: 44px;
    margin-top: 30px;
  }
  p {
    font-size: 14.5px;
    font-family: var(--sf-pro-text);
    color: #605e5c;
    line-height: 23px;
    letter-spacing: 0em;
    margin-bottom: 30px;
  }
  .topfeed {
    padding-top: 42px;
    p {
      text-align: center;
    }
  }
  .accept-check {
    margin-top: 18px;
    span {
      font-size: 14.5px;
      font-family: var(--sf-pro-text);
      color: #605e5c;
      font-style: normal;
    }
  }
  .boxFieldTitle {
    padding-left: 0px !important;
  }
  .feed-icon {
    width: 100px;
    height: 100px;
    margin: 0 auto 15px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .companyRights {
    display: flex;
    justify-content: space-between;
    padding-top: 35px;
    .companyLogo {
      width: 130px;
      margin-bottom: 15px;
      img {
        width: 100%;
      }
    }
    label {
      font-size: 14.5px;
      font-family: var(--sf-pro-text);
      color: #3b3a39;
      font-style: normal;
      display: block;
      margin-bottom: 3px;
    }
    ul {
      list-style: none;
      padding-left: 0px;
      margin-top: 14px;
      li {
        display: inline-block;
        width: 18px;
        height: 18px;
        margin-right: 24px;
        img {
          width: 100%;
        }
      }
    }
  }
  .companyAddress {
    h6 {
      font-family: var(--sf-pro-display-m);
      font-size: 16px;
      color: #000000;
    }
  }
`;
export const ProductionSet = styled.div`
  border: 1px solid #f3f2f1;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
  .prodset-header {
    display: flex;
    svg {
      align-self: center;
    }
  }
  .prodleft-header {
    padding-left: 12px;
    h4 {
      font-size: 16px;
      color: #000000;
      font-family: var(--sf-pro-display-m);
      line-height: 20px;
      display: flex;
      margin-bottom: 4px;
      span {
        display: table;
        padding: 1px 7px 1px;
        border-radius: 6px;
        font-size: 11.5px;
        margin-left: 15px;
        font-family: var(--sf-pro-display-m);
        line-height: 16px;
        &[dataset="Priority"] {
          background-color: rgba(234, 78, 44, 0.2);
          color: #ea4e2c;
        }
        &[datasetForStation="Station"] {
          background-color:  rgba(238, 149, 0, 0.1);
          color: #EE9500;;
        }
      }
    }
    label {
      color: #605e5c;
      font-size: 14px;
      font-family: var(--sf-pro-text);
      margin: 0;
    }
  }
  .prodset-body {
    padding-top: 7px;
    .prodset-sb {
      display: flex;
      justify-content: space-between;
    }
    .prodset-dt {
      display: flex;
      justify-content: space-between;
      padding: 8px 0;
      border-bottom: 1px solid #edebe9;
      &.prod-50 {
        flex: 0 0 47%;
        max-width: 47%;
      }
    }
    h5,
    p {
      font-size: 14px;
      line-height: 16px;
      margin: 0;
      padding: 2px 0;
    }
    h5 {
      font-family: var(--sf-pro-text);
      color: #605e5c;
    }
    p {
      font-family: var(--sf-pro-display-m);
      color: #201f1e;
    }
  }
  .prodset-footer {
    display: flex;
    justify-content: space-between;
    padding-top: 12px;
    label {
      margin: 0;
      font-size: 12px;
      color: #6b778c;
      font-family: var(--sf-pro-display-m);
      line-height: 20px;
    }
    span {
      padding: 2px 7px 2px;
      border-radius: 7px;
      font-size: 14px;
      font-family: var(--sf-pro-text);
      line-height: 20px;
      &[dataset="Produced"] {
        color: #107c10;
        background-color: #ecf9f0;
      }
      &[dataset="Mapped"] {
        color: #3485e0;
        background-color: #e3effc;
      }
      &[dataset="Cancelled"],
      &[dataset="Rejected"] {
        color: #ea4e2c;
        background-color: #fdeeea;
      }
      &[dataset="Not Mapped"] {
        color: #6a6866;
        background-color: #edebe9;
      }
    }
  }
`;
export const ProfilePort = styled.div`
  padding: 30px 0;
  border-bottom: 1px solid #edebe9;
  .bioPic {
    display: flex;
    justify-content: center;
    max-width: 290px;
    margin: 0px auto;
  }
  .bio-picImg {
    width: 82px;
    height: 82px;
    border-radius: 100%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .bio-data {
    padding-left: 15px;
    align-self: center;
    h5 {
      font-family: var(--sf-pro-display-m);
      font-size: 18px;
      color: #323130;
      margin-bottom: 5px;
      line-height: 1.2;
    }
    label {
      font-family: var(--sf-pro-display);
      font-size: 14px;
      color: #605e5c;
      margin: 0;
    }
  }
`;

export const ProfileImageUpload = styled.div`
  padding: 30px 0;
  .bioPic {
    display: flex;
    justify-content: center;
    max-width: 410px;
    margin: 0px auto;
  }
  .bio-picImg {
    width: 82px;
    height: 82px;
    border-radius: 100%;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      &#defaultPic {
        position: absolute;
        left: 0;
      }
    }
  }
  .bio-data {
    padding-left: 15px;
    align-self: center;
    &.bio-uploaded {
      display: flex;
    }
    h5 {
      font-family: var(--sf-pro-display-m);
      font-size: 18px;
      color: #323130;
      margin-bottom: 5px;
      line-height: 1.2;
    }
    label {
      font-family: var(--sf-pro-display);
      font-size: 14px;
      color: #605e5c;
      margin: 0;
    }
  }
  .uploadBtnFx {
    cursor: pointer;
    span {
      line-height: 21px;
    }
  }
`;

export const FilteredGrid = styled.div`
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  .MainFiltered {
    padding-bottom: 20px;
    ul {
      height: 210px;
      overflow-y: scroll;
      padding-bottom: 5px;
    }
    li {
      color: #000 !important;
      font-size: 12px;
      font-family: var(--sf-pro-display-m);
      line-height: 30px !important;
      height: 30px !important;
      margin: 0px !important;
      border-bottom: 1px solid #f3f2f1;
      &:focus,
      &:hover {
        background: #fdf0ef !important;
      }
    }
  }
  .MainFiltered ul::-webkit-scrollbar {
    width: 5px;
  }
  .MainFiltered ul::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.25);
  }
  .MainFiltered ul::-webkit-scrollbar-thumb {
    background-color: #b6b3b3;
    outline: 1px solid #d0d0d0;
    border-radius: 8px;
  }
`;

export const FilterComp = styled.div`
  width: 100%;
  &.filterTypeSelect {
    display: none;
    position: absolute;
    right: 0px;
    z-index: 1000;
    top: 45px;
    min-width: 260px;
    border-radius: 8px;
    height: 345px;
    background-color: #fff;
    box-shadow: 2px 4px 14px -3px rgba(0, 0, 0, 0.2);
    &.visibleTrue {
      display: flex;
      flex-wrap: wrap;
    }
    &.created_date,
    &.production_date,
    &.rewinding_date,
    &.delivery_date,
    &.po_date,
    &.closing_date {
      height: 390px;
      min-width: 415px;
    }
  }
  .gradeFiltered {
    width: 100%;
    ul {
      height: 135px;
      overflow-y: scroll;
      padding-bottom: 5px;
    }
    li {
      color: #000 !important;
      font-size: 12px;
      font-family: var(--sf-pro-display-m);
      line-height: 30px !important;
      height: 30px !important;
      margin: 0px !important;
      border-bottom: 1px solid #f3f2f1;
      &:focus,
      &:hover {
        background: #fdf0ef !important;
      }
      span {
        display: block;
        position: relative;
        .arrowSel {
          width: 6px;
          height: 6px;
          display: block;
          border-top: 2px solid #605e5c;
          border-right: 2px solid #605e5c;
          position: absolute;
          top: 12px;
          right: 0px;
          transform: rotate(45deg);
        }
      }
    }
  }
  .scrolled-ui ul::-webkit-scrollbar,
  .ant-checkbox-group::-webkit-scrollbar {
    width: 5px;
  }
  .scrolled-ui ul::-webkit-scrollbar-track,
  .ant-checkbox-group::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.25);
  }
  .scrolled-ui ul::-webkit-scrollbar-thumb,
  .ant-checkbox-group::-webkit-scrollbar-thumb {
    background-color: #b6b3b3;
    outline: 1px solid #d0d0d0;
    border-radius: 8px;
  }
  .ant-checkbox-group {
    height: 135px;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-bottom: 5px;
  }
  .searchFilt {
    border: 2px solid #dfe1e6;
    box-sizing: border-box;
    border-radius: 8px;
    height: 35px;
    width: 95%;
    margin: 7px;
  }
  .filterBtmClick {
    padding: 6px 10px 8px;
    display: flex;
    justify-content: center;
    margin-top: auto;

    width: 100%;
    button {
      width: 90px;
      min-height: 30px !important;
      border-radius: 8px !important;
      &:last-child {
        margin-right: 0px;
        svg {
          top: 2px;
        }
      }
      &.themeBtn-plane {
        border-color: #ea655b !important;
        svg {
          top: 2px;
          position: relative;
        }
        span {
          color: #ea655b !important;
          margin-left: 10px;
        }
      }
      span {
        font-size: 13px;
        font-family: var(--sf-pro-display);
        letter-spacing: 0.03em;
      }
    }
  }
  .qualityDroped {
    position: absolute;
    top: 0px;
    width: 260px;
    left: 262px;
    border-radius: 8px;
    height: 270px;
    background-color: #fff;
    box-shadow: 2px 4px 14px -3px rgba(0, 0, 0, 0.2);
    display: none;
    &.qualityEnabled {
      display: block;
    }
    ul {
      height: 175px;
    }
    .all-Qul {
      > div {
        margin: 0px;
      }
      .logCheck {
        padding: 0 10px;
      }
      span {
        font-size: 13px;
      }
    }
    .allQuality {
      font-size: 12px;
      font-family: var(--sf-pro-text);
      color: #a19f9d;
      margin: 0px;
      padding: 4px 10px 8px;
      display: block;
    }
  }
  .checkboxFilt {
    .ant-checkbox-indeterminate .ant-checkbox-inner::after {
      background-color: #ea655b;
    }
    label {
      padding: 5px 10px;
      border-bottom: 1px solid #f3f2f1;
    }
    .ant-checkbox-group {
      display: block;
      label {
        display: flex;
        width: 100%;
        padding: 5px 10px 3px;
      }
    }
    > div {
      margin: 0px !important;
      border-bottom: 1px solid #f3f2f1;
      span {
        font-size: 13px;
        color: #605e5c;
      }
    }
    .ant-form-item-control-input {
      min-height: auto;
      padding: 2px 10px;
      label {
        display: flex;
      }
    }
  }
  .filterRanged {
    width: 100%;
    form {
      padding: 10px 10px;
      > div {
        margin-bottom: 10px !important;
      }
      .ant-select-single .ant-select-selector .ant-select-selection-item {
        line-height: 31px;
      }
      .ant-select-selection-placeholder {
        line-height: 32px !important;
      }
      .removepadd input[type="text"] {
        padding-left: 10px !important;
      }
      input[type="text"] {
        height: 35px !important;
      }
    }
    .ant-select,
    .ant-select-selector {
      height: 35px;
    }
  }
  .backfilter {
    border: 0px;
    outline: none;
    background-color: transparent;
    padding: 0px 0px;
    height: 27px;
    position: absolute;
    top: 4px;
    width: 22px;
    left: 12px;
    span {
      width: 6px;
      height: 6px;
      display: block;
      border-top: 2px solid #605e5c;
      border-right: 2px solid #605e5c;
      position: absolute;
      top: 12px;
      right: 10px;
      transform: rotate(225deg);
    }
  }
`;

export const EditSetsContainer = styled.div`
display: flex;
width: 40%;
float: left;
.btn{
  transform: translateY(-2px);
  max-height: 18px;
  padding: 0;
  margin: 0 0 0 6px;
  background-color: transparent;
  border: 0px;
  width: 50%;
  float: left;
}
.edit-container{
  margin:0px;
  padding:0px;
  height: 10px;
  // padding-left: 3px;
  display: flex;
  width: 100%;
  float: left;
}
.input{
  height:20px;
  width:100%;
  font-size: 10px;
  padding: 1px;
  text-align: center;
  margin:5px 0px 0px 2px;
  transform: translateY(-9px);
}
.input_sheet{
  height:20px;
  width:100%;
  font-size: 10px;
  padding: 1px;
  text-align: center;
  margin:5px 0px 0px 2px;
  transform: translateY(-9px);
  border: 1px solid #d9d9d9;
}
.input_sheet:focus, .input:focus {
  border-color: #d9d9d9;
  outline: 0;
  -webkit-box-shadow: 0 0 0 2px rgba(87,168,233, .2);
  box-shadow: 0 0 0 2px rgba(87,168,233, .2);
}
.error{
  color: red;
  font-size: 9px;
  margin:0px;
  padding:0px;
  transform: translateY(-8px);
  line-height: 1;
}
`
export const CylinderShimmer = styled.div`
.shimmer{
  .ant-skeleton-paragraph{
    li{
      margin: 2px 0px;
    }
    margin:2px 0px;
  }
  ul{
    margin:2px 0px;
    width: 95%;
  }
  .ant-skeleton-title{
    margin: 2px 0px;
    width: 90% !important;
  }
}
`
export const SolutionContainer = styled.div`
{
  .ant-page-header-heading{
    height: 50px;
  }
  .ant-page-header-heading-title{
    font-size: 24px;
  }
}`

export const FlexContainer = styled.div`
  display:flex;
  align-items:center
  &.justify-center{
    justify-content:center;
  }
  &.justify-left{
    justify-content:flex-start;
  }
  &.justify-right{
    justify-content:flex-end;
  }
  &.justify-space-between{
    justify-content:space-between;
  }
`